// redux/slices/ahm.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  compareProducts: [],
  healthFund: '',
  selectedProduct: null,
};

const compareSlice = createSlice({
  name: 'ahm',
  initialState,
  reducers: {
    setComapreProducts: (state, action) => {
      state.compareProducts = action.payload;
    },
    setCompareHealthFund: (state, action) => {
      state.healthFund = action.payload;
    },
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
  },
});

export const { setComapreProducts, setCompareHealthFund, setSelectedProduct } =
  compareSlice.actions;

export default compareSlice.reducer;
